import Api from '@/data/Api.ts';
import StringUtils from '@/infrastructure/support/utils/StringUtils.ts';

const API_URL_GET_COMPANY_TICKETS = '/companies/{0}/tickets';
const URL_TICKET_TEMPLATES = '/companies/{0}/ticket-templates';

export default class TicketCompanyApi extends Api {
  /**
   * Get all tickets of a company. Optionally filtered and paginated.
   * And maybe even sorted but no promises...
   *
   * @param companyId The associated company id.
   * @param params The parameters to send with the request.
   * @param includes An array of relations to include with the entity e.g. ['plants', 'creator'].
   */
  getCompanyTickets(
    companyId: number,
    params: {} = {},
    includes: string[] = [],
  ): Promise<any> {
    const url: string = StringUtils.stringFormat(API_URL_GET_COMPANY_TICKETS, [
      companyId,
    ]);
    return this.standardGet(url, params, includes);
  }

  getCompanyTemplates(companyId: number): Promise<any> {
    const url: string = StringUtils.stringFormat(URL_TICKET_TEMPLATES, [
      companyId,
    ]);
    return this.standardGet(url, {}, []);
  }
}
